var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"id":"footer"}},[_c('v-spacer'),_c('div',{staticClass:"text-center"},[_vm._v("JKTech IT Solutions s.r.o. © "+_vm._s(new Date().getFullYear()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }